import { render } from "./vhpTabs.vue?vue&type=template&id=36c7ae7a"
import script from "./vhpTabs.vue?vue&type=script&lang=js"
export * from "./vhpTabs.vue?vue&type=script&lang=js"

import "./vhpTabs.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__